import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import routes from "./data/routes";
import { Provider } from "react-redux";
import store from "./redux/store";
import AuthBootstrap from "./AuthBootstrap";
import PageViewTracker from "./analytics/PageViewTracker";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <Router>
      <AuthBootstrap />
      <PageViewTracker />
      <Routes>
        {routes.map((route, index) => (
          <Route key={index} path={route.path} element={route.element} />
        ))}
      </Routes>
    </Router>
  </Provider>
);
